// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.toolbar[data-v-7b8eff5e] { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 10px; margin-bottom: 16px;\n}\n.toolbar .el-input[data-v-7b8eff5e] { width: 240px;\n}\n.danger[data-v-7b8eff5e] { color: #f56c6c;\n}\r\n", ""]);
// Exports
module.exports = exports;
